/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {MarkerListItem} from '../marker-list-item';
import {type MarkerListComponentModeController} from './marker-list-component-mode-controller';

export class CutlistMarkerListComponentModeController implements MarkerListComponentModeController {
  public isReorderingEnabled(): boolean {
    return true;
  }

  public sortMarkers(markers: MarkerListItem[]): MarkerListItem[] {
    return markers;
  }

  public getNextMarker(markers: MarkerListItem[], marker: MarkerListItem): MarkerListItem | undefined {
    const sortedMarkers = this.sortMarkers(markers);
    const currentIndex = sortedMarkers.findIndex((m) => m === marker);
    if (currentIndex < sortedMarkers.length - 1) {
      return sortedMarkers[currentIndex + 1];
    } else {
      return undefined;
    }
  }
}
